import React, { memo, useState, useEffect } from "react";
import { ChevronDown } from "lucide-react";

const MenuSection = memo(
  ({ 
    title, 
    children, 
    defaultOpen = true, 
    isDarkMode, 
    isCollapsed,
    isMobile = false,
    onItemClick
  }) => {
    const [isOpen, setIsOpen] = useState(defaultOpen || isMobile);

    useEffect(() => {
      if ((!isCollapsed && isCollapsed !== undefined) || isMobile) {
        setIsOpen(true);
      }
    }, [isCollapsed, isMobile]);

    const childrenArray = React.Children.toArray(children).map(child => 
      React.cloneElement(child, { isMobile, onItemClick })
    );

    if (isCollapsed && !isMobile) {
      return (
        <div className="mb-4 pt-1">
          <div
            className={`w-full flex justify-center px-1 py-1 mb-2 text-xs ${
              isDarkMode ? "text-gray-600" : "text-base-content/50"
            }`}
            title={title}
          >
            <div className="w-6 h-0.5 rounded-full bg-current opacity-40"></div>
          </div>
          <div className="space-y-2 py-1">{childrenArray}</div>
        </div>
      );
    }

    return (
      <div className="mb-3">
        <button
          onClick={() => setIsOpen(!isOpen)}
          className={`w-full flex items-center justify-between px-4 py-2 text-sm transition-colors ${
            isDarkMode
              ? "text-gray-500 hover:text-brand-logo-purple"
              : "text-base-content/70 hover:text-base-content/90"
          }`}
          aria-expanded={isOpen}
        >
          {title}
          <ChevronDown
            size={16}
            className={`transition-transform duration-200 ${
              isOpen ? "rotate-180" : ""
            }`}
          />
        </button>
        <div
          className={`space-y-1 overflow-hidden transition-all duration-300 ease-in-out ${
            isOpen ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
          }`}
        >
          {childrenArray}
        </div>
      </div>
    );
  }
);

export default MenuSection; 